module.exports = __webpack_public_path__ + "static/media/charging-station.a142915d.svg";